import { useMutation, useQuery } from "react-query"
import { Horse, saveTrainerType } from "../api/horses"
import { useState } from "react"
import { THorse } from "../shared/types/horse.type"
import { TTrainerHorse } from "../shared/types/trainerHorse.type"
import { get, isEmpty } from "lodash"
import { toast } from "react-toastify"
import { t } from "i18next"
import { hydraTransform } from "../shared/utils/hydraTransformer"

export const useHorses = (enableQuery: boolean = false, trainer?: string, options:
    {
        horses?: Record<string, any>,
        rawHorseOptions?: string
    } =
    { horses: { page: 1, itemsPerPage: 100 } }) => {

    const [total, setTotal] = useState(0)
    const updateHorseTrainerMutation = useMutation(({ id, data }: { id: number, data: Partial<TTrainerHorse> }) => Horse.updateHorseStatus(id, data))
    const checkMicroshipMutation = useMutation((microchip: string) => Horse.checkMicroship(microchip))
    const saveHorseTrainerMutation = useMutation((data: saveTrainerType) => Horse.saveTrainerHorse(data))
    const getBreedsMutation = useMutation(({ inList = false }: { inList?: boolean }) => Horse.getBreeds(inList))
    const saveHorseMutation = useMutation((data: Partial<THorse>) => Horse.saveHorse(data))
    const updateHorseMutation = useMutation(({ id, data }: { id: number, data: Partial<THorse> }) => Horse.updateHorse(id, data))

    const queryHorses = useQuery(['horses', options,trainer], ({ signal }) => Horse.getHorses(trainer, options?.horses, options?.rawHorseOptions, signal), {
        enabled: enableQuery && !isEmpty(trainer),
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        cacheTime: 900000,
        onSuccess: ({ data }) => {
            setTotal(get(data, 'hydra:totalItems', 0))
        }
    })


    const changeHorseStatus = (id: number, data: Partial<TTrainerHorse>) => {
        updateHorseTrainerMutation.mutateAsync({ id, data })
            .then(result => {
                queryHorses.refetch()
            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })
            })
    }


    return {
        horses: hydraTransform(queryHorses.data?.data ?? []),
        changeHorseStatus,
        getBreeds: getBreedsMutation,
        updateHorse: updateHorseMutation,
        saveHorse: saveHorseMutation,
        checkMicroship: checkMicroshipMutation,
        saveHorseTrainer: saveHorseTrainerMutation,
        isSavingHorseTrainer: saveHorseTrainerMutation.isLoading,
        isHorseUpdating: updateHorseTrainerMutation.isLoading,
        isLoadingHorses: queryHorses.isLoading || queryHorses.isFetching,
        reloadHorses: () => queryHorses.refetch(),
        total
    }
}